import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { GeneralService } from '../../../services/general.service';
import { ResetPassword } from '../../../models/resetPassword';
@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css'],
})
export class RecoverPasswordComponent implements OnInit {
  public username;
  public pass = '';
  public pass1 = '' ;
  public expires;

  public identity;

  public newPassword: ResetPassword;

  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private _generalService: GeneralService
  ) {
    this.newPassword = new ResetPassword('', '', '');
  }

  ngOnInit() {
    this.identity = this._generalService.getIdentity();
    this.activeRouter.queryParamMap.subscribe((params) => {
      this.expires = params.get('expire');
      this.username = params.get('username');
      console.log(this.username);
      if (!this.username && !this.expires) {
        this.router.navigate(['/login']);
      }
      if (this.identity) {
        Swal.fire({
          title: 'Uy!',
          icon: 'error',
          text: 'Ya iniciaste sesion, por facor cierrala para continuar',
        }).then(() => {
          this.router.navigate(['/']);
        });
      }
    });
  }

  onSubmit(form) {  
    if(!this.validateSimil()){
      Swal.fire({
        title: 'Error',
        icon: 'error',
        html: `
          <p>Por favor, asegúrese de cumplir con las siguientes condiciones para su contraseña:</p>
          <ul>
            <li>La contraseña debe contener al menos 4 caracteres.</li>
            <li>La contraseña debe contener al menos un número, una letra mayúscula, una minúscula y 4 caracteres.</li>
            <li>Las contraseñas deben coincidir.</li>
          </ul>
        `,
      });
      this.pass = '';
      this.pass1 = '';
      return;
    }
    console.log(this.pass);
    this.newPassword.email = atob(this.username);
    this.newPassword.expire = this.expires;
    this.newPassword.newPassword = this.pass;
    let object = {
      data: this.newPassword,
      url: 'Authentication/ResetPassword',
    };

    // loguear al usaurio y conseguir sus datos}
    this._generalService.postObjectFree(object).subscribe(
      (response) => {
        console.log(response);
        if (!response) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Algo salio mal..',
          });
        } else {
          Swal.fire({
            title: 'Felicidades',
            icon: 'success',
            text: 'Se restauro su contraseña, Inice sesion nuevamente',
          }).then((result) => {
            if (result) {
              this.router.navigate(['/login']);
            }
          });
        }
      },
      (error) => {
        const errorMessage = error as any;
        console.warn(error);
        if (errorMessage != null) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: error.error,
          }).then((result) => {
            if (result) {
              this.router.navigate(['/login']);
            }
          });
        }
      }
    );
  }

  validateSimil() {
    const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,}$/;
    if (this.pass.length === 0 || !pattern.test(this.pass) || this.pass !== this.pass1) {
      return false;
    } else {
      return true;
    }
  }
  
}
